// This file is autogenerated, all your changes will be overwritten!
// If you want to change anything go to /tools/hl7/src/index.ts and adjust the template!
import { HL7MessageType } from '@lmt/shared-types';

export const HL7MessageTypeNamesDict = {
  [HL7MessageType.Unknown]: 'Unknown',
  [HL7MessageType.ADR_A19]: 'ADR_A19 - Patient Query - Response',
  [HL7MessageType.ADT_A01]: 'ADT_A01 - Admit/visit notification',
  [HL7MessageType.ADT_A02]: 'ADT_A02 - Transfer a patient',
  [HL7MessageType.ADT_A03]: 'ADT_A03 - Discharge/end visit',
  [HL7MessageType.ADT_A04]: 'ADT_A04 - Register a patient',
  [HL7MessageType.ADT_A05]: 'ADT_A05 - Pre-admit a patient',
  [HL7MessageType.ADT_A06]: 'ADT_A06 - Change an outpatient to an inpatient',
  [HL7MessageType.ADT_A07]: 'ADT_A07 - Change an inpatient to an outpatient',
  [HL7MessageType.ADT_A08]: 'ADT_A08 - Update patient information',
  [HL7MessageType.ADT_A09]: 'ADT_A09 - Patient departing - tracking',
  [HL7MessageType.ADT_A10]: 'ADT_A10 - Patient arriving - tracking',
  [HL7MessageType.ADT_A11]: 'ADT_A11 - Cancel admit/visit notification',
  [HL7MessageType.ADT_A12]: 'ADT_A12 - Cancel transfer',
  [HL7MessageType.ADT_A13]: 'ADT_A13 - Cancel discharge/end visit',
  [HL7MessageType.ADT_A14]: 'ADT_A14 - Pending admit',
  [HL7MessageType.ADT_A15]: 'ADT_A15 - Pending transfer',
  [HL7MessageType.ADT_A16]: 'ADT_A16 - Pending discharge',
  [HL7MessageType.ADT_A17]: 'ADT_A17 - Swap patients',
  [HL7MessageType.ADT_A18]:
    'ADT_A18 - Merge patient information (for backward compatibility only)',
  [HL7MessageType.ADT_A20]: 'ADT_A20 - Bed status update',
  [HL7MessageType.ADT_A21]: 'ADT_A21 - Patient goes on a leave of absence',
  [HL7MessageType.ADT_A22]: 'ADT_A22 - Patient returns from a leave of absence',
  [HL7MessageType.ADT_A23]: 'ADT_A23 - Delete a patient record',
  [HL7MessageType.ADT_A24]: 'ADT_A24 - Link patient information',
  [HL7MessageType.ADT_A25]: 'ADT_A25 - Cancel pending discharge',
  [HL7MessageType.ADT_A26]: 'ADT_A26 - Cancel pending transfer',
  [HL7MessageType.ADT_A27]: 'ADT_A27 - Cancel pending admit',
  [HL7MessageType.ADT_A28]: 'ADT_A28 - Add person information',
  [HL7MessageType.ADT_A29]: 'ADT_A29 - Delete person information',
  [HL7MessageType.ADT_A30]:
    'ADT_A30 - Merge person information (for backward compatibility only)',
  [HL7MessageType.ADT_A31]: 'ADT_A31 - Update person information',
  [HL7MessageType.ADT_A32]: 'ADT_A32 - Cancel patient arriving - tracking',
  [HL7MessageType.ADT_A33]: 'ADT_A33 - Cancel patient departing - tracking',
  [HL7MessageType.ADT_A34]:
    'ADT_A34 - Merge patient information - patient ID only (for backward compatibili',
  [HL7MessageType.ADT_A35]:
    'ADT_A35 - Merge patient information - account number only (for backward compati',
  [HL7MessageType.ADT_A36]:
    'ADT_A36 - Merge patient information - patient ID and account number (for backwa',
  [HL7MessageType.ADT_A37]: 'ADT_A37 - Unlink patient information',
  [HL7MessageType.ADT_A38]: 'ADT_A38 - Cancel pre-admit',
  [HL7MessageType.ADT_A39]:
    'ADT_A39 - Merge person - patient ID (for backward compatibility only)',
  [HL7MessageType.ADT_A40]: 'ADT_A40 - Merge patient - patient identifier list',
  [HL7MessageType.ADT_A41]: 'ADT_A41 - Merge account - patient account number',
  [HL7MessageType.ADT_A42]: 'ADT_A42 - Merge visit - visit number',
  [HL7MessageType.ADT_A43]:
    'ADT_A43 - Move patient information - patient identifier list',
  [HL7MessageType.ADT_A44]:
    'ADT_A44 - Move account information - patient account number',
  [HL7MessageType.ADT_A45]: 'ADT_A45 - Move visit information - visit number',
  [HL7MessageType.ADT_A46]:
    'ADT_A46 - Change patient ID (for backward compatibility only)',
  [HL7MessageType.ADT_A47]: 'ADT_A47 - Change patient identifier list',
  [HL7MessageType.ADT_A48]:
    'ADT_A48 - Change alternate patient ID (for backward compatibility only)',
  [HL7MessageType.ADT_A49]: 'ADT_A49 - Change patient account number',
  [HL7MessageType.ADT_A50]: 'ADT_A50 - Change visit number',
  [HL7MessageType.ADT_A51]: 'ADT_A51 - Change alternate visit ID',
  [HL7MessageType.ADT_A52]: 'ADT_A52 - Cancel leave of absence for a patient',
  [HL7MessageType.ADT_A53]:
    'ADT_A53 - Cancel patient returns from a leave of absence',
  [HL7MessageType.ADT_A54]: 'ADT_A54 - Change attending doctor',
  [HL7MessageType.ADT_A55]: 'ADT_A55 - Cancel change attending doctor',
  [HL7MessageType.ADT_A60]: 'ADT_A60 - Update allergy information',
  [HL7MessageType.ADT_A61]: 'ADT_A61 - Change consulting doctor',
  [HL7MessageType.ADT_A62]: 'ADT_A62 - Cancel change consulting doctor',
  [HL7MessageType.BAR_P01]: 'BAR_P01 - Add patient accounts',
  [HL7MessageType.BAR_P02]: 'BAR_P02 - Purge patient accounts',
  [HL7MessageType.BAR_P05]: 'BAR_P05 - Update account',
  [HL7MessageType.BAR_P06]: 'BAR_P06 - End account',
  [HL7MessageType.BAR_P10]:
    'BAR_P10 - Transmit Ambulatory Payment Classification(APC)',
  [HL7MessageType.BAR_P12]: 'BAR_P12 - Update Diagnosis/Procedure',
  [HL7MessageType.BPS_O29]: 'BPS_O29 - Blood product dispense status',
  [HL7MessageType.BRP_O30]:
    'BRP_O30 - Blood product dispense status acknowledgment',
  [HL7MessageType.BRT_O32]:
    'BRT_O32 - Blood product transfusion/disposition acknowledgment',
  [HL7MessageType.BTS_O31]: 'BTS_O31 - Blood product transfusion/disposition',
  [HL7MessageType.CRM_C01]: 'CRM_C01 - Register a patient on a clinical trial',
  [HL7MessageType.CRM_C02]:
    'CRM_C02 - Cancel a patient registration on clinical trial (for clerical mistakes onl',
  [HL7MessageType.CRM_C03]: 'CRM_C03 - Correct/update registration information',
  [HL7MessageType.CRM_C04]: 'CRM_C04 - Patient has gone off a clinical trial',
  [HL7MessageType.CRM_C05]: 'CRM_C05 - Patient enters phase of clinical trial',
  [HL7MessageType.CRM_C06]:
    'CRM_C06 - Cancel patient entering a phase (clerical mistake)',
  [HL7MessageType.CRM_C07]: 'CRM_C07 - Correct/update phase information',
  [HL7MessageType.CRM_C08]:
    'CRM_C08 - Patient has gone off phase of clinical trial',
  [HL7MessageType.CSU_C09]:
    'CSU_C09 - Automated time intervals for reporting, like monthly',
  [HL7MessageType.CSU_C10]: 'CSU_C10 - Patient completes the clinical trial',
  [HL7MessageType.CSU_C11]:
    'CSU_C11 - Patient completes a phase of the clinical trial',
  [HL7MessageType.CSU_C12]:
    'CSU_C12 - Update/correction of patient order/result information',
  [HL7MessageType.DFT_P03]: 'DFT_P03 - Post detail financial transaction',
  [HL7MessageType.DFT_P11]:
    'DFT_P11 - Post Detail Financial Transactions - New',
  [HL7MessageType.DOC_T12]: 'DOC_T12 - Document Query - Response',
  [HL7MessageType.EAC_U07]: 'EAC_U07 - Automated equipment command',
  [HL7MessageType.EAN_U09]: 'EAN_U09 - Automated equipment notification',
  [HL7MessageType.EAR_U08]: 'EAR_U08 - Automated equipment response',
  [HL7MessageType.EHC_E01]: 'EHC_E01 - Submit HealthCare Services Invoice',
  [HL7MessageType.ESR_U02]: 'ESR_U02 - Automated equipment status request',
  [HL7MessageType.ESU_U01]: 'ESU_U01 - Automated equipment status update',
  [HL7MessageType.INR_U06]: 'INR_U06 - Automated equipment inventory request',
  [HL7MessageType.INU_U05]: 'INU_U05 - Automated equipment inventory update',
  [HL7MessageType.LSR_U13]: 'LSR_U13 - Automated equipment log/service request',
  [HL7MessageType.LSU_U12]: 'LSU_U12 - Automated equipment log/service update',
  [HL7MessageType.MDM_T01]: 'MDM_T01 - Original document notification',
  [HL7MessageType.MDM_T02]:
    'MDM_T02 - Original document notification and content',
  [HL7MessageType.MDM_T03]: 'MDM_T03 - Document status change notification',
  [HL7MessageType.MDM_T04]:
    'MDM_T04 - Document status change notification and content',
  [HL7MessageType.MDM_T05]: 'MDM_T05 - Document addendum notification',
  [HL7MessageType.MDM_T06]:
    'MDM_T06 - Document addendum notification and content',
  [HL7MessageType.MDM_T07]: 'MDM_T07 - Document edit notification',
  [HL7MessageType.MDM_T08]: 'MDM_T08 - Document edit notification and content',
  [HL7MessageType.MDM_T09]: 'MDM_T09 - Document replacement notification',
  [HL7MessageType.MDM_T10]:
    'MDM_T10 - Document replacement notification and content',
  [HL7MessageType.MDM_T11]: 'MDM_T11 - Document cancel notification',
  [HL7MessageType.MFK_M01]:
    'MFK_M01 - Master File - Not Otherwise Specified (for Backward Compatibility Only) - Response',
  [HL7MessageType.MFN_M01]:
    'MFN_M01 - Master file not otherwise specified (for backward compatibility only)',
  [HL7MessageType.MFN_M02]: 'MFN_M02 - Master file - staff practitioner',
  [HL7MessageType.MFN_M03]:
    'MFN_M03 - Master file - test/observation (for backward compatibility only)',
  [HL7MessageType.MFN_M04]: 'MFN_M04 - Master files charge description',
  [HL7MessageType.MFN_M05]: 'MFN_M05 - Patient location master file',
  [HL7MessageType.MFN_M06]:
    'MFN_M06 - Clinical study with phases and schedules master file',
  [HL7MessageType.MFN_M07]:
    'MFN_M07 - Clinical study without phases but with schedules master file',
  [HL7MessageType.MFN_M08]: 'MFN_M08 - Test/observation (numeric) master file',
  [HL7MessageType.MFN_M09]:
    'MFN_M09 - Test/observation (categorical) master file',
  [HL7MessageType.MFN_M10]: 'MFN_M10 - Test /observation batteries master file',
  [HL7MessageType.MFN_M11]:
    'MFN_M11 - Test/calculated observations master file',
  [HL7MessageType.MFN_M12]: 'MFN_M12 - Master file notification message',
  [HL7MessageType.MFN_M13]: 'MFN_M13 - Master file notification - general',
  [HL7MessageType.MFN_M14]: 'MFN_M14 - Master file notification - site defined',
  [HL7MessageType.MFN_M15]: 'MFN_M15 - Inventory item master file notification',
  [HL7MessageType.NMD_N02]:
    'NMD_N02 - Application management data message (unsolicited)',
  [HL7MessageType.NMQ_N01]: 'NMQ_N01 - Application management query message',
  [HL7MessageType.NMR_N01]:
    'NMR_N01 - Application Management Query Message - Response',
  [HL7MessageType.OMB_O27]: 'OMB_O27 - Blood product order',
  [HL7MessageType.OMD_O03]: 'OMD_O03 - Diet order',
  [HL7MessageType.OMG_O19]: 'OMG_O19 - General clinical order',
  [HL7MessageType.OMI_O23]: 'OMI_O23 - Imaging order',
  [HL7MessageType.OML_O21]: 'OML_O21 - Laboratory order',
  [HL7MessageType.OML_O33]:
    'OML_O33 - Laboratory order for multiple orders related to a single specimen',
  [HL7MessageType.OML_O35]:
    'OML_O35 - Laboratory order for multiple orders related to a single container of a sp',
  [HL7MessageType.OMN_O07]: 'OMN_O07 - Non-stock requisition order',
  [HL7MessageType.OMP_O09]: 'OMP_O09 - Pharmacy/treatment order',
  [HL7MessageType.OMS_O05]: 'OMS_O05 - Stock requisition order',
  [HL7MessageType.ORB_O28]: 'ORB_O28 - Blood product order acknowledgment',
  [HL7MessageType.ORD_O04]: 'ORD_O04 - Diet order acknowledgment',
  [HL7MessageType.ORF_R04]:
    'ORF_R04 - Response to query; transmission of requested observation',
  [HL7MessageType.ORG_O20]: 'ORG_O20 - General clinical order response',
  [HL7MessageType.ORI_O24]:
    'ORI_O24 - Imaging order response message to any OMI',
  [HL7MessageType.ORL_O22]:
    'ORL_O22 - General laboratory order response message to any OML',
  [HL7MessageType.ORL_O34]:
    'ORL_O34 - Laboratory order response message to a multiple order related to single sp',
  [HL7MessageType.ORL_O36]:
    'ORL_O36 - Laboratory order response message to a single container of a specimen OML',
  [HL7MessageType.ORM_O01]: 'ORM_O01 - Order message',
  [HL7MessageType.ORN_O08]: 'ORN_O08 - Non-stock requisition acknowledgment',
  [HL7MessageType.ORP_O10]: 'ORP_O10 - Pharmacy/treatment order acknowledgment',
  [HL7MessageType.ORR_O02]:
    'ORR_O02 - Order response (also RRE, RRD, RRG, RRA)',
  [HL7MessageType.ORS_O06]: 'ORS_O06 - Stock requisition acknowledgment',
  [HL7MessageType.ORU_R01]:
    'ORU_R01 - Unsolicited transmission of an observation message',
  [HL7MessageType.ORU_R30]:
    'ORU_R30 - Unsolicited Point-Of-Care Observation Message Without Existing Order - Pla',
  [HL7MessageType.ORU_R31]:
    'ORU_R31 - Unsolicited New Point-Of-Care Observation Message - Search For An Order',
  [HL7MessageType.ORU_R32]:
    'ORU_R32 - Unsolicited Pre-Ordered Point-Of-Care Observation',
  [HL7MessageType.ORU_R40]: 'ORU_R40 - Unsolicited Alert Observation Message',
  [HL7MessageType.OSQ_Q06]: 'OSQ_Q06 - Query for order status',
  [HL7MessageType.OSR_Q06]: 'OSR_Q06 - Query For Order Status - Response',
  [HL7MessageType.OUL_R21]: 'OUL_R21 - Unsolicited laboratory observation',
  [HL7MessageType.OUL_R22]:
    'OUL_R22 - Unsolicited Specimen Oriented Observation Message',
  [HL7MessageType.OUL_R23]:
    'OUL_R23 - Unsolicited Specimen Container Oriented Observation Message',
  [HL7MessageType.OUL_R24]:
    'OUL_R24 - Unsolicited Order Oriented Observation Message',
  [HL7MessageType.PEX_P07]:
    'PEX_P07 - Unsolicited initial individual product experience report',
  [HL7MessageType.PEX_P08]:
    'PEX_P08 - Unsolicited update individual product experience report',
  [HL7MessageType.PGL_PC6]: 'PGL_PC6 - PC/ goal add',
  [HL7MessageType.PGL_PC7]: 'PGL_PC7 - PC/ goal update',
  [HL7MessageType.PGL_PC8]: 'PGL_PC8 - PC/ goal delete',
  [HL7MessageType.PIN_I07]: 'PIN_I07 - Unsolicited insurance information',
  [HL7MessageType.PMU_B01]: 'PMU_B01 - Add personnel record',
  [HL7MessageType.PMU_B02]: 'PMU_B02 - Update personnel record',
  [HL7MessageType.PMU_B03]: 'PMU_B03 - Delete personnel re cord',
  [HL7MessageType.PMU_B04]: 'PMU_B04 - Active practicing person',
  [HL7MessageType.PMU_B05]: 'PMU_B05 - Deactivate practicing person',
  [HL7MessageType.PMU_B06]: 'PMU_B06 - Terminate practicing person',
  [HL7MessageType.PMU_B07]: 'PMU_B07 - Grant Certificate/Permission',
  [HL7MessageType.PMU_B08]: 'PMU_B08 - Revoke Certificate/Permission',
  [HL7MessageType.PPG_PCG]: 'PPG_PCG - PC/ pathway (goal-oriented) add',
  [HL7MessageType.PPG_PCH]: 'PPG_PCH - PC/ pathway (goal-oriented) update',
  [HL7MessageType.PPG_PCJ]: 'PPG_PCJ - PC/ pathway (goal-oriented) delete',
  [HL7MessageType.PPP_PCB]: 'PPP_PCB - PC/ pathway (problem-oriented) add',
  [HL7MessageType.PPP_PCC]: 'PPP_PCC - PC/ pathway (problem-oriented) update',
  [HL7MessageType.PPP_PCD]: 'PPP_PCD - PC/ pathway (problem-oriented) delete',
  [HL7MessageType.PPR_PC1]: 'PPR_PC1 - PC/ problem add',
  [HL7MessageType.PPR_PC2]: 'PPR_PC2 - PC/ problem update',
  [HL7MessageType.PPR_PC3]: 'PPR_PC3 - PC/ problem delete',
  [HL7MessageType.PPT_PCL]:
    'PPT_PCL - PC/ pathway (goal-oriented) query response',
  [HL7MessageType.PPV_PCA]: 'PPV_PCA - PC/ goal response',
  [HL7MessageType.PRR_PC5]: 'PRR_PC5 - PC/ problem response',
  [HL7MessageType.PTR_PCF]:
    'PTR_PCF - PC/ pathway (problem-oriented) query response',
  [HL7MessageType.QBP_Q11]:
    'QBP_Q11 - Query by parameter requesting an RSP segment pattern response',
  [HL7MessageType.QBP_Q13]:
    'QBP_Q13 - Query by parameter requesting an RTB - tabular response',
  [HL7MessageType.QBP_Q15]:
    'QBP_Q15 - Query by parameter requesting an RDY display response',
  [HL7MessageType.QBP_Q21]: 'QBP_Q21 - Get person demographics',
  [HL7MessageType.QBP_Q22]: 'QBP_Q22 - Find candidates',
  [HL7MessageType.QBP_Q23]: 'QBP_Q23 - Get corresponding identifiers',
  [HL7MessageType.QBP_Q24]: 'QBP_Q24 - Allocate identifiers',
  [HL7MessageType.QBP_Q25]: 'QBP_Q25 - Personnel Information by Segment Query',
  [HL7MessageType.QBP_Q31]: 'QBP_Q31 - QBP Query Dispense history',
  [HL7MessageType.QBP_Z73]: 'QBP_Z73 - Information about Phone Calls',
  [HL7MessageType.QBP_Z75]: 'QBP_Z75 - Tabular Patient List',
  [HL7MessageType.QBP_Z77]: 'QBP_Z77 - Tabular Patient List',
  [HL7MessageType.QBP_Z79]: 'QBP_Z79 - Dispense Information',
  [HL7MessageType.QBP_Z81]: 'QBP_Z81 - Dispense History',
  [HL7MessageType.QBP_Z85]: 'QBP_Z85 - Pharmacy Information Comprehensive',
  [HL7MessageType.QBP_Z87]: 'QBP_Z87 - Dispense Information ',
  [HL7MessageType.QBP_Z89]: 'QBP_Z89 - Lab Results History',
  [HL7MessageType.QBP_Z91]: 'QBP_Z91 - Who Am I',
  [HL7MessageType.QBP_Z93]: 'QBP_Z93 - Tabular Dispense History',
  [HL7MessageType.QBP_Z95]: 'QBP_Z95 - Tabular Dispense History',
  [HL7MessageType.QBP_Z97]: 'QBP_Z97 - Dispense History',
  [HL7MessageType.QBP_Z99]: 'QBP_Z99 - Who Am I',
  [HL7MessageType.QBP_ZV1]: 'QBP_ZV1 - Query Patient Demographics And Visit',
  [HL7MessageType.QCN_J01]: 'QCN_J01 - Cancel query/acknowledge message',
  [HL7MessageType.QRY_A19]: 'QRY_A19 - Patient query',
  [HL7MessageType.QRY_PC4]: 'QRY_PC4 - PC/ problem query',
  [HL7MessageType.QRY_PC9]: 'QRY_PC9 - PC/ goal query',
  [HL7MessageType.QRY_PCE]: 'QRY_PCE - PC/ pathway (problem-oriented) query',
  [HL7MessageType.QRY_PCK]: 'QRY_PCK - PC/ pathway (goal-oriented) query',
  [HL7MessageType.QRY_Q26]: 'QRY_Q26 - Pharmacy/treatment order response',
  [HL7MessageType.QRY_Q27]:
    'QRY_Q27 - Pharmacy/treatment administration information',
  [HL7MessageType.QRY_Q28]: 'QRY_Q28 - Pharmacy/treatment dispense information',
  [HL7MessageType.QRY_Q29]:
    'QRY_Q29 - Pharmacy/treatment encoded order information',
  [HL7MessageType.QRY_Q30]: 'QRY_Q30 - Pharmacy/treatment dose information',
  [HL7MessageType.QRY_R02]: 'QRY_R02 - Query for results of observation',
  [HL7MessageType.QRY_T12]: 'QRY_T12 - Document query',
  [HL7MessageType.QSB_Q16]: 'QSB_Q16 - Create subscription',
  [HL7MessageType.QSB_Z83]: 'QSB_Z83 - ORU Subscription',
  [HL7MessageType.QSX_J02]: 'QSX_J02 - Cancel subscription/acknowledge message',
  [HL7MessageType.QVR_Q17]: 'QVR_Q17 - Query for previous events',
  [HL7MessageType.RAR_RAR]:
    'RAR_RAR - Pharmacy/Treatment Administration Information',
  [HL7MessageType.RAS_O17]: 'RAS_O17 - Pharmacy/treatment administration',
  [HL7MessageType.RCL_I06]:
    'RCL_I06 - Request/Receipt Of Clinical Data Listing - Response',
  [HL7MessageType.RDE_O11]: 'RDE_O11 - Pharmacy/treatment encoded order',
  [HL7MessageType.RDE_O25]:
    'RDE_O25 - Pharmacy/treatment refill authorization request',
  [HL7MessageType.RDR_RDR]:
    'RDR_RDR - Pharmacy/Treatment Dispense Information - Response',
  [HL7MessageType.RDS_O13]: 'RDS_O13 - Pharmacy/treatment dispense',
  [HL7MessageType.RDY_K15]: 'RDY_K15 - Display response in response to',
  [HL7MessageType.RDY_Z80]: 'RDY_Z80 - Dispense Information (Response)',
  [HL7MessageType.RDY_Z98]: 'RDY_Z98 - Dispense History (Response)',
  [HL7MessageType.REF_I12]: 'REF_I12 - Patient referral',
  [HL7MessageType.REF_I13]: 'REF_I13 - Modify patient referral',
  [HL7MessageType.REF_I14]: 'REF_I14 - Cancel patient referral',
  [HL7MessageType.REF_I15]: 'REF_I15 - Request patient referral status',
  [HL7MessageType.REF_I16]: 'REF_I16 - Collaborative care referral',
  [HL7MessageType.REF_I17]: 'REF_I17 - Modify collaborative care referral',
  [HL7MessageType.REF_I18]: 'REF_I18 - Cancel collaborative care referral',
  [HL7MessageType.RER_RER]:
    'RER_RER - Pharmacy/Treatment Encoded Order Information',
  [HL7MessageType.RGR_RGR]: 'RGR_RGR - Pharmacy/Treatment Dose Information',
  [HL7MessageType.RGV_O15]: 'RGV_O15 - Pharmacy/treatment give',
  [HL7MessageType.ROR_ROR]:
    'ROR_ROR - Pharmacy prescription order query response',
  [HL7MessageType.RPA_I08]:
    'RPA_I08 - Request For Treatment Authorization Information - Response',
  [HL7MessageType.RPI_I01]:
    'RPI_I01 - Request For Insurance Information - Response',
  [HL7MessageType.RPI_I04]:
    'RPI_I04 - Request For Patient Demographic Data - Response',
  [HL7MessageType.RPL_I02]:
    'RPL_I02 - Request/Receipt Of Patient Selection Display List - Response',
  [HL7MessageType.RPR_I03]:
    'RPR_I03 - Request/Receipt Of Patient Selection List - Response',
  [HL7MessageType.RQA_I08]:
    'RQA_I08 - Request for treatment authorization information',
  [HL7MessageType.RQA_I09]:
    'RQA_I09 - Request for modification to an authorization',
  [HL7MessageType.RQA_I10]:
    'RQA_I10 - Request for resubmission of an authorization',
  [HL7MessageType.RQA_I11]:
    'RQA_I11 - Request for cancellation of an authorization',
  [HL7MessageType.RQC_I05]:
    'RQC_I05 - Request for patient clinical information',
  [HL7MessageType.RQC_I06]:
    'RQC_I06 - Request/receipt of clinical data listing',
  [HL7MessageType.RQI_I01]: 'RQI_I01 - Request for insurance information',
  [HL7MessageType.RQI_I02]:
    'RQI_I02 - Request/receipt of patient selection display list',
  [HL7MessageType.RQI_I03]:
    'RQI_I03 - Request/receipt of patient selection list',
  [HL7MessageType.RQP_I04]: 'RQP_I04 - Request for patient demographic data',
  [HL7MessageType.RRA_O18]:
    'RRA_O18 - Pharmacy/treatment administration acknowledgment',
  [HL7MessageType.RRD_O14]:
    'RRD_O14 - Pharmacy/treatment dispense acknowledgment',
  [HL7MessageType.RRE_O12]:
    'RRE_O12 - Pharmacy/treatment encoded order acknowledgment',
  [HL7MessageType.RRE_O26]:
    'RRE_O26 - Pharmacy/Treatment Refill Authorization Acknowledgement',
  [HL7MessageType.RRG_O16]: 'RRG_O16 - Pharmacy/treatment give acknowledgment',
  [HL7MessageType.RRI_I12]: 'RRI_I12 - Patient Referral - Response',
  [HL7MessageType.RRI_I13]: 'RRI_I13 - Modify patient referral - Response',
  [HL7MessageType.RRI_I14]: 'RRI_I14 - Cancel patient referral - Response',
  [HL7MessageType.RRI_I15]:
    'RRI_I15 - Request patient referral status - Response',
  [HL7MessageType.RRI_I16]: 'RRI_I16 - Collaborative care referral - Response',
  [HL7MessageType.RRI_I17]:
    'RRI_I17 - Modify collaborative care referral - Response',
  [HL7MessageType.RRI_I18]:
    'RRI_I18 - Cancel collaborative care referral - Response',
  [HL7MessageType.RSP_K11]: 'RSP_K11 - Segment pattern response in response to',
  [HL7MessageType.RSP_K21]: 'RSP_K21 - Get person demographics response',
  [HL7MessageType.RSP_K22]: 'RSP_K22 - Find candidates response',
  [HL7MessageType.RSP_K23]: 'RSP_K23 - Get corresponding identifiers response',
  [HL7MessageType.RSP_K24]: 'RSP_K24 - Allocate identifiers response',
  [HL7MessageType.RSP_K25]:
    'RSP_K25 - Personnel Information by Segment Response',
  [HL7MessageType.RSP_K31]: 'RSP_K31 - Dispense History Response',
  [HL7MessageType.RSP_Z82]: 'RSP_Z82 - Dispense History (Response)',
  [HL7MessageType.RSP_Z84]: 'RSP_Z84 - Who Am I (Response)',
  [HL7MessageType.RSP_Z86]:
    'RSP_Z86 - Pharmacy Information Comprehensive (Response)',
  [HL7MessageType.RSP_Z88]: 'RSP_Z88 - Dispense Information (Response)',
  [HL7MessageType.RSP_Z90]: 'RSP_Z90 - Lab Results History (Response)',
  [HL7MessageType.RSV_ZV2]:
    'RSV_ZV2 - Query Patient Demographics And Visit Response',
  [HL7MessageType.RTB_K13]: 'RTB_K13 - Tabular response in response to',
  [HL7MessageType.RTB_Z74]:
    'RTB_Z74 - Information about Phone Calls (Response)',
  [HL7MessageType.RTB_Z76]: 'RTB_Z76 - Tabular Patient List (Response)',
  [HL7MessageType.RTB_Z78]: 'RTB_Z78 - Tabular Patient List (Response)',
  [HL7MessageType.RTB_Z92]: 'RTB_Z92 - Who Am I (Response)',
  [HL7MessageType.RTB_Z94]: 'RTB_Z94 - Tabular Dispense History (Response)',
  [HL7MessageType.RTB_Z96]: 'RTB_Z96 - Tabular Dispense History (Response)',
  [HL7MessageType.SIU_S12]: 'SIU_S12 - Notification of new appointment booking',
  [HL7MessageType.SIU_S13]:
    'SIU_S13 - Notification of appointment rescheduling',
  [HL7MessageType.SIU_S14]:
    'SIU_S14 - Notification of appointment modification',
  [HL7MessageType.SIU_S15]:
    'SIU_S15 - Notification of appointment cancellation',
  [HL7MessageType.SIU_S16]:
    'SIU_S16 - Notification of appointment discontinuation',
  [HL7MessageType.SIU_S17]: 'SIU_S17 - Notification of appointment deletion',
  [HL7MessageType.SIU_S18]:
    'SIU_S18 - Notification of addition of service/resource on appointment',
  [HL7MessageType.SIU_S19]:
    'SIU_S19 - Notification of modification of service/resource on appointment',
  [HL7MessageType.SIU_S20]:
    'SIU_S20 - Notification of cancellation of service/resource on appointment',
  [HL7MessageType.SIU_S21]:
    'SIU_S21 - Notification of discontinuation of service/resource on appointment',
  [HL7MessageType.SIU_S22]:
    'SIU_S22 - Notification of deletion of service/resource on appointment',
  [HL7MessageType.SIU_S23]:
    'SIU_S23 - Notification of blocked schedule time slot(s)',
  [HL7MessageType.SIU_S24]:
    'SIU_S24 - Notification of opened (unblocked) schedule time slot(s)',
  [HL7MessageType.SIU_S26]:
    'SIU_S26 - SIU/ACK Notification that patient did not show up for schedule appointment',
  [HL7MessageType.SQM_S25]: 'SQM_S25 - Schedule query message and response',
  [HL7MessageType.SQR_S25]: 'SQR_S25 - Schedule Query Message And Responsem',
  [HL7MessageType.SRM_S01]: 'SRM_S01 - Request new appointment booking',
  [HL7MessageType.SRM_S02]: 'SRM_S02 - Request appointment rescheduling',
  [HL7MessageType.SRM_S03]: 'SRM_S03 - Request appointment modification',
  [HL7MessageType.SRM_S04]: 'SRM_S04 - Request appointment cancellation',
  [HL7MessageType.SRM_S05]: 'SRM_S05 - Request appointment discontinuation',
  [HL7MessageType.SRM_S06]: 'SRM_S06 - Request appointment deletion',
  [HL7MessageType.SRM_S07]:
    'SRM_S07 - Request addition of service/resource on appointment',
  [HL7MessageType.SRM_S08]:
    'SRM_S08 - Request modification of service/resource on appointment',
  [HL7MessageType.SRM_S09]:
    'SRM_S09 - Request cancellation of service/resource on appointment',
  [HL7MessageType.SRM_S10]:
    'SRM_S10 - Request discontinuation of service/resource on appointment',
  [HL7MessageType.SRM_S11]:
    'SRM_S11 - Request deletion of service/resource on appointment',
  [HL7MessageType.SRR_S01]:
    'SRR_S01 - Request New Appointment Booking - Response',
  [HL7MessageType.SSR_U04]: 'SSR_U04 - specimen status request',
  [HL7MessageType.SSU_U03]: 'SSU_U03 - Specimen status update',
  [HL7MessageType.SUR_P09]: 'SUR_P09 - Summary product experience report',
  [HL7MessageType.TCR_U11]:
    'TCR_U11 - Automated equipment test code settings request',
  [HL7MessageType.TCU_U10]:
    'TCU_U10 - Automated equipment test code settings update',
  [HL7MessageType.VXQ_V01]: 'VXQ_V01 - Query for vaccination record',
  [HL7MessageType.VXR_V03]: 'VXR_V03 - Vaccination record response',
  [HL7MessageType.VXU_V04]: 'VXU_V04 - Unsolicited vaccination record update',
  [HL7MessageType.VXX_V02]:
    'VXX_V02 - Response to vaccination query returning multiple PID matches',
};
